// extracted by mini-css-extract-plugin
export default {"Table":"styles_Table__jpOvx","Actions":"styles_Actions__MbbFF","DropDown":"styles_DropDown__Yq+az"};